/** WHAT THE BROWSER KEEPS AT REST passes through here, both ways: every
 *  value the pack store and the island store write to IndexedDB, and every
 *  value they read back. Today it is kept as it is. Encryption at rest is
 *  post-merge (Tom, 2026-10-19): a key the server issues per (user,
 *  organisation), held in memory only — it goes in these two functions
 *  (reviews, 2026-10-19). A value that cannot be read back is "not stored". */

export async function toRest<T>(value: T): Promise<unknown> {
  return value;
}

export async function fromRest<T>(stored: unknown): Promise<T | undefined> {
  return stored === undefined || stored === null ? undefined : (stored as T);
}
